type ColorScheme = {
  primary: string
  secondary: string
  tertiary: string
  highlight: string
}

type ColorPaletteProps = {
  colorScheme: ColorScheme
}

const ColorPalette = (props: ColorPaletteProps) => {
  const { colorScheme } = props

  const primaryStyle = { backgroundColor: colorScheme.primary }
  const secondaryStyle = { backgroundColor: colorScheme.secondary }
  const tertiaryStyle = { backgroundColor: colorScheme.tertiary }
  const highlightStyle = { backgroundColor: colorScheme.highlight }
  return (
    <div className="color-palette">
      <div
        className="color-palette__color"
        style={primaryStyle}
        data-color="primary"
        title={`Primary color: ${colorScheme.primary}`}
      >
        <div className="content" />
      </div>
      <div
        className="color-palette__color"
        style={secondaryStyle}
        data-color="secondary"
        title={`Secondary color: ${colorScheme.secondary}`}
      >
        <div className="content" />
      </div>
      <div
        className="color-palette__color"
        style={tertiaryStyle}
        data-color="tertiary"
        title={`Tertiary color: ${colorScheme.tertiary}`}
      >
        <div className="content" />
      </div>
      <div
        className="color-palette__color"
        style={highlightStyle}
        data-color="highlight"
        title={`Highlight color: ${colorScheme.highlight}`}
      >
        <div className="content" />
      </div>
    </div>
  )
}
export default ColorPalette
